export default function moveFocusToNextFocusableElementOnDeletion() {
  const focusableEls = Array.from(
    document.querySelectorAll('[focusable], [href], object, embed, [tabindex]:not([disabled]), [contenteditable]')
  );
  const focusedEl = document.activeElement;

  if (focusedEl) {
    const focusedElIndex = focusableEls.indexOf(focusedEl);
    (focusableEls[focusedElIndex + 1] as HTMLElement).focus();
  }
}



// WEBPACK FOOTER //
// ./app/lib/global/utilities/move_focus_to_next_focusable_element_on_deletion.ts